import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { euronodesAuth, initialAuthCallback } from '../lib/euronodesAuth'

export default function EuronodesAuthComplete() {
  const [state, setState] = useState({ loading: true, message: '' })

  useEffect(() => {
    let active = true
    async function finish() {
      if (initialAuthCallback?.error) {
        if (active) setState({ loading: false, message: initialAuthCallback.error })
        return
      }

      if (!euronodesAuth) {
        if (active) setState({
          loading: false,
          message: 'Απαιτείται η ρύθμιση του VITE_EURONODES_SUPABASE_ANON_KEY στο περιβάλλον δημοσίευσης. Το email επαληθεύτηκε, αλλά η συνεδρία στο Codevaro Projects δεν ολοκληρώθηκε.'
        })
        return
      }

      try {
        if (initialAuthCallback?.accessToken && initialAuthCallback?.refreshToken) {
          const { error } = await euronodesAuth.auth.setSession({
            access_token: initialAuthCallback.accessToken,
            refresh_token: initialAuthCallback.refreshToken
          })
          if (error) throw error
        }
        const { data: { user }, error } = await euronodesAuth.auth.getUser()
        if (error || !user) throw error || new Error('Δεν βρέθηκε ενεργή συνεδρία.')
        if (active) setState({ loading: false, message: 'Το email σας επιβεβαιώθηκε επιτυχώς και ολοκληρώθηκε η σύνδεση στο Codevaro Projects.' })
      } catch {
        if (active) setState({ loading: false, message: 'Η συνεδρία δεν ενεργοποιήθηκε. Ζητήστε νέο σύνδεσμο επιβεβαίωσης.' })
      }
    }
    finish()
    return () => { active = false }
  }, [])

  return (
    <main className="min-h-screen bg-gray-50 flex items-center justify-center px-4">
      <section className="w-full max-w-lg rounded-xl bg-white p-8 shadow">
        <h1 className="text-2xl font-bold text-gray-900 mb-4">Επιβεβαίωση λογαριασμού Codevaro Projects</h1>
        <p className="text-gray-700" role="status">
          {state.loading ? 'Ολοκλήρωση επαλήθευσης...' : state.message}
        </p>
        <p className="mt-4 text-sm text-gray-500">Η πρόσβαση σε έργα και υπηρεσίες θα ενεργοποιείται σύμφωνα με τα δικαιώματα του λογαριασμού σας.</p>
        <Link className="mt-6 inline-block text-blue-700 underline" to="/">Επιστροφή στην αρχική</Link>
      </section>
    </main>
  )
}